import 'CssFolder/eula.scss';
import 'CssFolder/privacy.scss';

import userModel from '../../models/user/user.model';
import ViewBase from '../view-base.view';

export default function AgreementCommonView() {
  const AGREEMENT_TYPE_MAP = {
    "eula": "End User License Agreement",
    "privacy": "Samsung Market Communication System Privacy Notice",
    "security-guideline": "Security Guideline for using Samsung Web Sites"
  }
  const SUBSIDIARY_COUNTRY_MAP = {
    savina: "VN",
    seau: "AU",
    sein: "ID",
    sesp: "SG",
    sepco: "PH",
    sme: "MY",
    tse: "TH",
    senz: "NZ",
  }
  ViewBase.call(this);
  let agreementDescription = ""
  const getCommonAgreements = () => {
    let agreementType = m.route.param("agreementType")
    let countryCode = SUBSIDIARY_COUNTRY_MAP[m.route.param("subsidiary")] ?? ""

    userModel.getCommonAgreements(countryCode)
      .then(res => {
        agreementDescription = res?.find(({ termName }) => termName === AGREEMENT_TYPE_MAP[agreementType])?.description ?? "";
      })
      .catch(error => {
        this.handleError(error);
      })
  }

  return {
    oninit: () => {
      getCommonAgreements()
    },
    view: (vnode) => {
      return m.trust(agreementDescription)
    }
  }
}
